/** Dedicated Naturals Portal — Enterprise franchise control (not salon/brand product consoles). */
export const ENTERPRISE_CONTROL_BASE = "/naturals-portal/naturals-control";
